/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ConfigSiteSelect_ConfigFragmentDoc } from './ConfigSiteSelect.graphql';
import { ConfigInlineGroupsSelect_ConfigFragmentDoc } from './ConfigInlineGroupsSelect.graphql';
import { ConfigSiteSelect_CustomerFragmentDoc } from './ConfigSiteSelect.graphql';
import { ConfigInlineGroupsSelect_CustomerFragmentDoc } from './ConfigInlineGroupsSelect.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigGeneralSection_ConfigFragment = { __typename: 'ConfigurationModel', id: string, name: string, site?: { __typename: 'Site', id: string, name: string, address?: string | null } | null, groups: Array<{ __typename: 'Group', id: string, name: string }> };

export type ConfigGeneralSection_CustomerFragment = { __typename: 'Customer', id: string, sites: Array<{ __typename: 'Site', id: string, name: string, address?: string | null }>, groups: Array<{ __typename: 'Group', id: string, name: string }> };

export type ConfigurationRenameMutationVariables = Types.Exact<{
  input: Types.ConfigurationRenameInput;
}>;


export type ConfigurationRenameMutation = { __typename: 'Mutation', configurationRename: { __typename: 'ConfigurationModel', id: string, name: string } };

export const ConfigGeneralSection_ConfigFragmentDoc = gql`
    fragment ConfigGeneralSection_config on ConfigurationModel {
  id
  name
  ...ConfigSiteSelect_config
  ...ConfigInlineGroupsSelect_config
}
    ${ConfigSiteSelect_ConfigFragmentDoc}
${ConfigInlineGroupsSelect_ConfigFragmentDoc}`;
export const ConfigGeneralSection_CustomerFragmentDoc = gql`
    fragment ConfigGeneralSection_customer on Customer {
  id
  ...ConfigSiteSelect_customer
  ...ConfigInlineGroupsSelect_customer
}
    ${ConfigSiteSelect_CustomerFragmentDoc}
${ConfigInlineGroupsSelect_CustomerFragmentDoc}`;
export const ConfigurationRenameDocument = gql`
    mutation ConfigurationRename($input: ConfigurationRenameInput!) {
  configurationRename(input: $input) {
    id
    name
  }
}
    `;
export type ConfigurationRenameMutationFn = ApolloReactCommon.MutationFunction<ConfigurationRenameMutation, ConfigurationRenameMutationVariables>;

/**
 * __useConfigurationRenameMutation__
 *
 * To run a mutation, you first call `useConfigurationRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigurationRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configurationRenameMutation, { data, loading, error }] = useConfigurationRenameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigurationRenameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigurationRenameMutation, ConfigurationRenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigurationRenameMutation, ConfigurationRenameMutationVariables>(ConfigurationRenameDocument, options);
      }
export type ConfigurationRenameMutationHookResult = ReturnType<typeof useConfigurationRenameMutation>;
export type ConfigurationRenameMutationResult = ApolloReactCommon.MutationResult<ConfigurationRenameMutation>;
export type ConfigurationRenameMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigurationRenameMutation, ConfigurationRenameMutationVariables>;